var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalfDayCalander(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M21.9998 14V12C21.9998 11.161 21.9868 9.665 21.9738 9H2.00578C1.99278 9.665 2.00578 11.161 2.00578 12V14C2.00578 17.771 2.00578 19.657 3.17578 20.828C4.34878 22 6.23378 22 10.0038 22H14.0038C17.7738 22 19.6578 22 20.8298 20.828C21.9998 19.657 21.9998 17.771 21.9998 14Z",
    fill: "#637381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96 2C7.378 2 7.716 2.31 7.716 2.692V4.09C8.386 4.078 9.138 4.078 9.984 4.078H14.016C14.862 4.078 15.613 4.078 16.284 4.09V2.692C16.284 2.31 16.622 2 17.04 2C17.458 2 17.796 2.31 17.796 2.692V4.15C19.246 4.256 20.199 4.518 20.899 5.158C21.599 5.799 21.884 6.671 22 8V9H2V8C2.116 6.671 2.401 5.8 3.101 5.158C3.801 4.518 4.753 4.256 6.204 4.15V2.692C6.204 2.31 6.543 2 6.96 2Z",
    fill: "#637381"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6726 17.0066C14.0787 16.6556 14.3981 16.3679 14.6307 16.1437C14.8676 15.9153 15.0643 15.6785 15.2208 15.4331C15.3773 15.1878 15.4555 14.9425 15.4555 14.6971C15.4555 14.4433 15.3942 14.2445 15.2715 14.1007C15.1531 13.9569 14.9649 13.885 14.7069 13.885C14.4573 13.885 14.2627 13.9653 14.1231 14.1261C13.9878 14.2826 13.9159 14.4941 13.9074 14.7606H13.2095C13.2222 14.2784 13.366 13.9104 13.6409 13.6566C13.9201 13.3985 14.2733 13.2695 14.7005 13.2695C15.1616 13.2695 15.5211 13.3964 15.7791 13.6502C16.0414 13.904 16.1725 14.2424 16.1725 14.6654C16.1725 14.9699 16.0943 15.2639 15.9378 15.5473C15.7855 15.8265 15.6015 16.0782 15.3858 16.3024C15.1743 16.5223 14.9035 16.7782 14.5736 17.0701L14.2881 17.3239H16.2994V17.9266H13.2158V17.4L13.6726 17.0066Z",
    fill: "#637381"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4564 12L10.7306 19.0999H10.02L11.7395 12H12.4564Z",
    fill: "#637381"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7002 14.0231V13.3633H9.01992V17.9887H8.29027V14.0231H7.7002Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfDayCalander);
export default __webpack_public_path__ + "static/media/half-day-calander.f26b13a37d027e38ba775d37f44e0f78.svg";
export { ForwardRef as ReactComponent };